import * as Season from 'types/Ingredient/Detail/Season';

export type Type = Season.Type[];

export function create(): Type {
	return [];
}
